import { useState } from 'react';
import { IFirstLastNameOption } from '.';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { AddressFormField } from '../../../puck/reusable-props/addressFormOptions';
import { IAddressOptions } from '../../../interface/formInterface';

const FirstLastNameHelper = ({
  value,
  onChange,
  name,
}: {
  value: IFirstLastNameOption;
  onChange: (_value: IFirstLastNameOption) => void;
  name: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{name}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          {Object?.keys(value || {})?.map((key, index) => {
            return (
              <AddressFormField
                formName={name}
                key={key}
                name={key}
                value={
                  value?.[key as keyof IFirstLastNameOption] ??
                  ({} as IAddressOptions)
                }
                onChange={newValue => onChange({ ...value, [key]: newValue })}
                index={(index || 0) + 10} // Ensure unique index for each field
              />
            );
          })}
        </div>
      )}
    </>
  );
};
export default FirstLastNameHelper;
